import React from 'react';
import { Flex, Rate } from 'antd';
import cbh from './CatalogBrandHeader.module.scss';
import { Typography } from 'antd';
import Link from 'next/link';
import Image from 'next/image';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

// @ts-ignore
const CatalogBrandHeader = ({ brand }) => {
    const LOCALIZATION = useLocalization();
    return (
        <Flex
            className={cbh.body}
            gap={'32px'}
            justify={'space-between'}
        >
            <Flex className={cbh.leftSide}>
                <Image
                    className={cbh.brandImage}
                    src={`${process.env.NEXT_PUBLIC_DOMAIN_CDN}${brand?.logo?.trim()}`}
                    width={0}
                    height={0}
                    sizes={'100%'}
                    alt={''}
                />
                <Flex
                    className={cbh.brandTitleBlock}
                    vertical
                >
                    <Typography.Text className={`text-32-500 text-[#8D24F8] whitespace-nowrap`}>
                        {brand?.fullname}
                    </Typography.Text>
                    {brand?.rating && (
                        <Rate
                            disabled
                            defaultValue={brand?.rating}
                            allowHalf
                        />
                    )}
                </Flex>
            </Flex>
            <Flex
                vertical
                className={cbh.rightSide}
            >
                <Typography.Text className={`text-16-400`}>{brand?.description}</Typography.Text>
                <Link
                    href={`/manufacturer/${brand?.slug}`}
                    className={`text-16-400 text-[#8D24F8]`}
                >
                    {LOCALIZATION.pages.catalog.catalogQuery.catalogBrandHeader.linkPage}
                </Link>
            </Flex>
        </Flex>
    );
};

export default CatalogBrandHeader;
